<template>
  <div class="app-top-div">
    <div class="network-connectivity-box" v-if="!isOnline">
      <div class="network-connectivity-wrapper">
        <div class="network-connectivity-container">
          <div class="network-connectivity-body">
              <slot name="body">
                <h2>{{$t('errorNetStr')}}</h2>
                <h3>接続された状態でご利用ください</h3>
              </slot>
          </div>
        </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'app',
  data () {
    return {
      isOnline: true
    }
  },
  mounted () {
    this.setIsAllowedIPAddressForManagementFromAPI()
    window.addEventListener('online', () => {
      this.isOnline = true
      this.setIsAllowedIPAddressForManagementFromAPI()
    })
    window.addEventListener('offline', () => {
      this.isOnline = false
    })
  },
  methods: {
    ...mapActions('repository/', {
      setIsAllowedIPAddressForManagement: 'setIsAllowedIPAddressForManagement',
      setIsAllowedIPAddressForManagementFromAPI: 'setIsAllowedIPAddressForManagementFromAPI'
    })
  }
}
</script>

<style lang="scss">
/* Import Font Awesome Icons Set */
@import "~flag-icon-css/css/flag-icon.min.css";
/* Import Font Awesome Icons Set */
$fa-font-path: "~font-awesome/fonts/";
@import "~font-awesome/css/font-awesome.min.css";
/* Import Simple Line Icons Set */
$simple-line-font-path: "~simple-line-icons/fonts/";
@import "~simple-line-icons/css/simple-line-icons.css";
/* Import Bootstrap Vue Styles */
@import "~bootstrap-vue/dist/bootstrap-vue.css";
// Import Main styles for this application
@import "./scss/style";
</style>



// WEBPACK FOOTER //
// src/App.vue